import { render } from "./Fotter.vue?vue&type=template&id=a35238ec&scoped=true"
import script from "./Fotter.vue?vue&type=script&lang=js"
export * from "./Fotter.vue?vue&type=script&lang=js"

import "./Fotter.vue?vue&type=style&index=0&id=a35238ec&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35238ec"]])

export default __exports__